
define('jst!tasks/tour/_step4',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<h1><%= t("Privacy #tasksfeaturetour") %></h1>\n<p><%= t("All the tasks you create for yourself, only you can see. For all the other ones (that are connected to something on Podio), you can choose whether they should be visible to everyone in a workspace or just between you and the assignee. #tasksfeaturetour") %></p>\n');
 });

